import { createContext, useContext } from 'react';
import { LayoutContextValues } from 'common/types/store';

export type LayoutContextType = LayoutContextValues;

const LayoutContext = createContext<LayoutContextType>({
  pageTitle: null,
  setPageTitle: () => {},
  pageFilters: null,
  setPageFilters: () => {},
  navItems: [],
  setNavItems: () => {},
  extraPageActions: null,
  setExtraPageActions: () => {},
  viewOnlyUser: false,
  currentFirmRole: null,
  setShowAlert: () => {},
  showAlert: false,
  openBulkActionsDialog: false,
  toggleBulkActionsDialog: () => {},
  updatePageActions: () => { },
  isExportMode: false,
  exportTab: '',
  openPdfDialog: false,
  togglePdfDialog: () => {},
});

LayoutContext.displayName = 'LayoutContext';

export const useLayoutContext = () => useContext(LayoutContext);

export default LayoutContext;
